import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setAuthHeader } from './apiHelpers';
import { liveAppUrl, demoAppUrl, localAppUrl } from '../../config';

const currentURL = window.location.href;
const appURL = currentURL.includes('localhost') ? localAppUrl : currentURL.includes('glidix') ? demoAppUrl : liveAppUrl;

export const pageApi = createApi({
  reducerPath: 'pageApi',
  baseQuery: fetchBaseQuery({
    baseUrl: appURL,
    prepareHeaders: (headers) => {
      setAuthHeader(headers);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchPage: builder.query({
      query: (params) => {
        if (params?.search) {
          return `/page/list?page=${params?.page ? params?.page : 1}&perPage=${params?.perPage ? params?.perPage : 10}&search=${params.search}`;
        } else {
          return `/page/list?page=${params?.page ? params?.page : 1}&perPage=${params?.perPage ? params?.perPage : 10}`;
        }
      }
    }),
    fetchPageDetail: builder.query({
      query: (id) => `/page/detail/${id}`,
    }),
    createPage: builder.mutation({
      query: (credentials) => ({
        url: '/page/store',
        method: 'POST',
        body: credentials,
      }),
    }),
    updatePage: builder.mutation({
      query: (credentials) => ({
        url: '/page/update',
        method: 'PUT',
        body: credentials,
      }),
    }),
    deletePage: builder.mutation({
      query: (id) => ({
        url: `/page/delete/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useFetchPageQuery,
  useFetchPageDetailQuery,
  useCreatePageMutation,
  useUpdatePageMutation,
  useDeletePageMutation
} = pageApi;
